/* eslint-disable @typescript-eslint/no-shadow */
import { storyblokEditable } from "@storyblok/react";
import { FC, ReactNode, useEffect } from "react";

import Container from "@/components/elements/Container";
import Section from "@/components/elements/Section";
import StandardText, {
  StandardTextSize,
} from "@/components/elements/StandardText";
import { useStore } from "@/lib/store";

export interface HeroBasicProps {
  children?: ReactNode;
  story: any;
  blok: any;
  pre_headline?: string;
  headline?: string;
  content?: string;
  actions: [];
  large_heading?: string;
  gapBottom?: string;
  image?: object;
  video?: object;
}

const HeroRaw: FC<HeroBasicProps> = ({
  children,
  blok,
  pre_headline = blok.hero_pre_heading,
  headline = blok.hero_heading,
  content = blok.hero_content,
  actions = blok.actions,
}) => {
  const setHeaderLight = useStore(({ setHeaderLight }) => setHeaderLight);
  useEffect(() => {
    setHeaderLight(true);
  }, []);

  if (blok.showHero === false) return <>{children}</>;

  return (
    <Section className={`relative`} {...storyblokEditable(blok)} gapBottom="xs">
      {children}
      <Container
        size="full"
        gutter='none'
        className={`relative z-10 ${
          blok.header_theme === "dark" ? "dark bg-theme-black" : ""
        }`}
      >
        <div className="mt-8 py-24 pr-12 relative z-1 mx-auto px-4 sm:px-6 md:px-8 lg:px-10 xl:px-16 2xl:px-20 3xl:px-24">
          <StandardText
            blok={{ headline, pre_headline, content, actions }}
            size={StandardTextSize.MD}
          />
        </div>
      </Container>
      {!headline && <div className="mt-4 py-16"></div>}
    </Section>
  );
};

export default HeroRaw;
